import TablaMaestra from "./TablaMaestra";


function Maestra({ darkMode }) {

    return (
      <TablaMaestra darkMode={darkMode}></TablaMaestra>
    );
}

export default Maestra;